import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CREstimateDefaultItemsBody,
  CREstimateDefaultItemsBodyAPI,
  CREstimateDefaultItemsKey,
  CREstimateDefaultItemsSummary,
  CREstimateDefaultItemsSummaryAPI,
  EstimateDefaultItemsActions,
  EstimateDefaultItemsState,
} from './types';

type AnyEstimateDefaultItems =
  | CREstimateDefaultItemsKey
  | CREstimateDefaultItemsSummary
  | CREstimateDefaultItemsBody
  | undefined;

function sameKeyEstimateDefaultItems(
  a: AnyEstimateDefaultItems,
  b: AnyEstimateDefaultItems,
): boolean {
  return a?.estimateItemId === b?.estimateItemId;
}

function getEndpointEstimateDefaultItems(key: AnyEstimateDefaultItems): string {
  return key
    ? `/estimate-default-items/${key.estimateItemId}/`
    : '/estimate-default-items/';
}

function parseEstimateDefaultItemsSummary(
  estimateDefaultItemsSummary: CREstimateDefaultItemsSummaryAPI,
): CREstimateDefaultItemsSummary {
  return estimateDefaultItemsSummary;
}

function parseEstimateDefaultItemsBody(
  estimateDefaultItemsDetail: CREstimateDefaultItemsBodyAPI,
): CREstimateDefaultItemsBody {
  return estimateDefaultItemsDetail;
}

const estimateDefaultItemsStateSelector = (
  state: any,
): EstimateDefaultItemsState => state.estimateDefaultItems;

const estimateDefaultItemsKeySelector = ({
  estimateItemId,
}:
  | CREstimateDefaultItemsBody
  | CREstimateDefaultItemsSummary): CREstimateDefaultItemsKey => ({
  estimateItemId,
});

function mergeEstimateDefaultItemsBody(
  lastBody: CREstimateDefaultItemsBody,
  currentBody: CREstimateDefaultItemsBody,
) {
  return currentBody;
}

function combineSummaryBodyEstimateDefaultItems(
  summary?: CREstimateDefaultItemsSummary,
  body?: CREstimateDefaultItemsBody,
): CREstimateDefaultItemsSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    ...summary,
    rowKey: summary?.rowKey ?? body?.rowKey ?? '',
    estimateItemId: merge('estimateItemId'),
    estimateItemName: merge('estimateItemName'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'estimateDefaultItems',
  getEndpointEstimateDefaultItems,
  estimateDefaultItemsStateSelector,
  sameKeyEstimateDefaultItems,
  parseEstimateDefaultItemsBody,
  parseEstimateDefaultItemsSummary,
  mergeEstimateDefaultItemsBody,
  combineSummaryBodyEstimateDefaultItems,
);

const estimateDefaultItemsActions: EstimateDefaultItemsActions = actions;
export * from './types';
export {
  estimateDefaultItemsActions,
  reducer as estimateDefaultItemsReducer,
  watches as estimateDefaultItemsWatches,
  estimateDefaultItemsStateSelector,
  estimateDefaultItemsKeySelector,
};
